import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const languages = [
    { code: 'ro', name: 'Română'},
    { code: 'en', name: 'English'},
    { code: 'hu', name: 'Magyar'}
  ];

  const handleLanguageChange = (event) => {
    i18n.changeLanguage(event.target.value);
  };

  return (
    <FormControl fullWidth variant="outlined" size="small">
      <InputLabel id="language-switcher-label" className="dark:text-white">{t('language.title')}</InputLabel>
      <Select
        labelId="language-switcher-label"
        id="language-switcher"
        value={i18n.language}
        onChange={handleLanguageChange}
        label={t('language.title')}
                    className="bg-white dark:bg-slate-700 dark:text-white"
      >
        {languages.map((language) => (
          <MenuItem key={language.code} value={language.code}>
            <div className="flex items-center space-x-2">
              <span>{language.name}</span>
            </div>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguageSwitcher;
